/* Trovéo — interactions & animations */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const T = window.troveo || {};

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('#Toast'); if (!el) return;
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------- Découpage des titres en mots ---------- */
  function splitWords(root = document) {
    $$('[data-split]', root).forEach(el => {
      if (el.dataset.splitDone) return;
      let i = 0;
      const walk = node => {
        Array.from(node.childNodes).forEach(child => {
          if (child.nodeType === 3) {
            const frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(part => {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              const w = document.createElement('span'); w.className = 'w';
              const inner = document.createElement('span'); inner.textContent = part;
              w.style.setProperty('--wi', i++); w.appendChild(inner); frag.appendChild(w);
            });
            child.replaceWith(frag);
          } else if (child.nodeType === 1) walk(child);
        });
      };
      walk(el);
      el.classList.add('split-words');
      el.dataset.splitDone = '1';
    });
  }

  /* ---------- Révélation au scroll ---------- */
  let io;
  function initReveal(root = document) {
    splitWords(root);
    const targets = $$('[data-reveal], .split-words', root);
    if (!document.body.classList.contains('anim-on') || reduce || !('IntersectionObserver' in window)) {
      targets.forEach(t => t.classList.add('is-visible')); return;
    }
    io = io || new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(t => io.observe(t));
  }

  /* ---------- Compteurs animés ---------- */
  function initCounters(root = document) {
    $$('[data-count]', root).forEach(el => {
      const end = parseFloat(el.dataset.count) || 0;
      const dec = (el.dataset.count.split('.')[1] || '').length;
      const suffix = el.dataset.suffix || '';
      if (reduce) { el.textContent = end.toFixed(dec) + suffix; return; }
      const run = () => {
        const t0 = performance.now(), dur = 1600;
        const step = now => {
          const p = Math.min((now - t0) / dur, 1), k = 1 - Math.pow(1 - p, 4);
          el.textContent = (end * k).toFixed(dec).replace('.', ',') + suffix;
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };
      const o = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { run(); o.disconnect(); } }));
      o.observe(el);
    });
  }

  /* ---------- Header : rétrécit et se cache au scroll ---------- */
  function initHeader() {
    const wrap = $('.header-wrap'); if (!wrap) return;
    let last = 0, ticking = false;
    const sticky = wrap.dataset.sticky;
    window.addEventListener('scroll', () => {
      if (ticking) return; ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        wrap.classList.toggle('is-scrolled', y > 20);
        if (sticky === 'smart') wrap.classList.toggle('is-hidden', y > last && y > 300);
        last = y; ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Tiroirs (menu mobile, panier) ---------- */
  let lastFocus;
  function openDrawer(id) {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => { const f = $('[data-close], button, a', d.querySelector('.drawer__panel')); f && f.focus(); }, 80);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.openDrawer); return; }
    const closer = e.target.closest('[data-close]');
    if (closer) { const d = closer.closest('.drawer, .search-modal'); if (d) { e.preventDefault(); d.classList.contains('drawer') ? closeDrawer(d) : closeSearch(); } }
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer); closeSearch();
  });

  /* ---------- Recherche ---------- */
  function closeSearch() { const m = $('.search-modal'); if (m) m.classList.remove('is-open'); }
  document.addEventListener('click', e => {
    if (e.target.closest('[data-open-search]')) {
      e.preventDefault(); const m = $('.search-modal'); if (!m) return;
      m.classList.add('is-open'); setTimeout(() => $('input', m).focus(), 150);
    }
  });

  /* ---------- Panier AJAX ---------- */
  async function refreshCart(open = true) {
    try {
      const res = await fetch(`${T.routes.root_url.replace(/\/$/, '')}/?sections=cart-drawer`);
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = $('#CartDrawer', html), cur = $('#CartDrawer');
      if (fresh && cur) {
        $('.drawer__panel', cur).innerHTML = $('.drawer__panel', fresh).innerHTML;
        const count = parseInt(fresh.dataset.count || '0', 10);
        $$('[data-cart-count]').forEach(c => {
          c.textContent = count; c.classList.toggle('is-empty', count === 0);
          c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump');
        });
      }
      if (open && T.cartType === 'drawer') openDrawer('CartDrawer');
    } catch (err) { console.error(err); }
  }

  async function addToCart(form, btn) {
    btn && btn.classList.add('is-loading');
    try {
      const res = await fetch(T.routes.cart_add_url, {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      const data = await res.json();
      if (data.status) { toast(data.description || data.message); return; }
      if (T.cartType === 'page') { window.location = T.routes.cart_url; return; }
      toast(form.dataset.addedMsg || 'Ajouté au panier !');
      await refreshCart(true);
    } catch (err) { form.submit(); }
    finally { btn && btn.classList.remove('is-loading'); }
  }

  document.addEventListener('submit', e => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type=submit]'));
  });

  async function changeLine(line, quantity, row) {
    row && row.classList.add('is-removing');
    try {
      await fetch(T.routes.cart_change_url, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      await refreshCart(false);
    } catch (err) { console.error(err); }
  }

  document.addEventListener('click', e => {
    const rm = e.target.closest('[data-line-remove]');
    if (rm && rm.closest('#CartDrawer')) { e.preventDefault(); changeLine(+rm.dataset.lineRemove, 0, rm.closest('.cart-item')); return; }
    const q = e.target.closest('[data-qty]');
    if (!q) return;
    const wrap = q.closest('.qty'), input = $('input', wrap);
    const min = parseInt(input.min || '0', 10);
    let v = parseInt(input.value || '1', 10) + (q.dataset.qty === 'plus' ? 1 : -1);
    v = Math.max(min, v); input.value = v;
    if (wrap.dataset.line && wrap.closest('#CartDrawer')) changeLine(+wrap.dataset.line, v, wrap.closest('.cart-item'));
    else input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Page produit ---------- */
  function initProduct(root = document) {
    $$('[data-product]', root).forEach(p => {
      const json = $('script[data-variants]', p); if (!json) return;
      const variants = JSON.parse(json.textContent);
      const form = $('form[data-ajax-cart]', p);
      const idInput = $('input[name=id]', form);
      const btn = $('[type=submit]', form);
      const priceEl = $('[data-price]', p);
      const stockEl = $('[data-stock]', p);
      const main = $('.product__main img', p);
      const L = p.dataset;

      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: p.dataset.currency || 'EUR' }).format(cents / 100);

      const update = () => {
        const selected = $$('fieldset.option', p).map(f => { const c = $('input:checked', f); return c ? c.value : null; });
        const v = variants.find(x => x.options.every((o, i) => o === selected[i]));
        $$('fieldset.option', p).forEach((f, i) => { const s = $('legend span', f); if (s) s.textContent = selected[i] || ''; });
        if (!v) { btn.disabled = true; btn.querySelector('span').textContent = L.unavailable; return; }
        idInput.value = v.id;
        btn.disabled = !v.available;
        btn.querySelector('span').textContent = v.available ? L.addLabel : L.soldOut;
        if (priceEl) {
          const sale = v.compare_at_price && v.compare_at_price > v.price;
          priceEl.classList.toggle('price--sale', !!sale);
          priceEl.innerHTML = `<span class="price__current">${money(v.price)}</span>${sale ? `<s>${money(v.compare_at_price)}</s>` : ''}`;
        }
        if (stockEl) stockEl.hidden = !v.available;
        if (v.featured_image && main) {
          main.style.opacity = 0;
          setTimeout(() => { main.src = v.featured_image.src + (v.featured_image.src.includes('?') ? '&' : '?') + 'width=1200'; main.srcset = ''; main.style.opacity = 1; }, 200);
        }
        const sticky = $('.sticky-atc [name=id]'); if (sticky) sticky.value = v.id;
        const url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      };
      $$('fieldset.option input', p).forEach(i => i.addEventListener('change', update));

      // Galerie
      $$('.product__thumbs button', p).forEach(b => b.addEventListener('click', () => {
        $$('.product__thumbs button', p).forEach(x => x.setAttribute('aria-current', 'false'));
        b.setAttribute('aria-current', 'true');
        main.style.opacity = 0;
        setTimeout(() => { main.src = b.dataset.src; main.srcset = ''; main.style.opacity = 1; }, 180);
      }));
      // Zoom au survol
      const zoom = $('.product__main', p);
      if (zoom && matchMedia('(hover:hover)').matches) {
        zoom.addEventListener('mousemove', e => {
          const r = zoom.getBoundingClientRect();
          main.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
        });
        zoom.addEventListener('mouseenter', () => zoom.classList.add('is-zoom'));
        zoom.addEventListener('mouseleave', () => zoom.classList.remove('is-zoom'));
      }
      // Barre d'achat collante
      const sticky = $('.sticky-atc');
      if (sticky && btn) {
        new IntersectionObserver(([e]) => sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(btn);
      }
    });
  }

  /* ---------- Parallaxe légère ---------- */
  function initParallax() {
    const els = $$('.js-parallax, [data-parallax]'); if (!els.length || reduce) return;
    let ticking = false;
    const run = () => {
      els.forEach(el => {
        const r = el.parentElement.getBoundingClientRect();
        const p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        el.style.transform = `scale(1.15) translateY(${p * -40}px)`;
      });
      ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* ---------- Hero : pattes qui marchent ---------- */
  function initPaws() {
    $$('.paws').forEach(wrap => {
      if (reduce || wrap.dataset.done) return;
      wrap.dataset.done = '1';
      const svg = wrap.dataset.svg; const n = 9;
      for (let i = 0; i < n; i++) {
        const s = document.createElement('span');
        s.innerHTML = svg;
        const el = s.firstElementChild;
        const x = 6 + i * 10.5, y = 86 - i * 8 + (i % 2 ? 6 : -2);
        el.style.left = x + '%'; el.style.top = y + '%';
        el.style.setProperty('--r', (40 + (i % 2 ? 15 : -15)) + 'deg');
        el.style.animationDelay = (i * 0.45) + 's';
        wrap.appendChild(el);
      }
    });
    $$('.hero').forEach(h => requestAnimationFrame(() => h.classList.add('is-loaded')));
  }

  /* ---------- Boutons magnétiques ---------- */
  function initMagnetic() {
    if (reduce || !matchMedia('(hover:hover)').matches) return;
    $$('[data-magnetic]').forEach(b => {
      b.addEventListener('mousemove', e => {
        const r = b.getBoundingClientRect();
        b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * .25}px, ${(e.clientY - r.top - r.height / 2) * .35}px)`;
      });
      b.addEventListener('mouseleave', () => { b.style.transform = ''; });
    });
  }

  /* ---------- Tri de collection ---------- */
  document.addEventListener('change', e => {
    if (e.target.matches('[data-sort]')) {
      const url = new URL(location.href); url.searchParams.set('sort_by', e.target.value); location.href = url;
    }
  });

  /* ---------- Init ---------- */
  function init(root) { initReveal(root); initCounters(root); initProduct(root); }
  document.addEventListener('DOMContentLoaded', () => {
    init(document); initHeader(); initParallax(); initPaws(); initMagnetic();
  });
  // Éditeur de thème
  document.addEventListener('shopify:section:load', e => { init(e.target); initPaws(); });
})();
